import { useState, FC, useEffect } from 'react';
import { translate } from 'translations';
import { AccordionTable, CollapseTableData } from 'learning-panel-components';
import { getRow, UserData } from '../leaderboard/userLeaderboard/userLeaderboard';
import styles from './emptyLeaderboard.module.scss';

const UserLeaderboard: FC<UserLeaderboardProps> = (props: UserLeaderboardProps) => {
    const { currentUser, users, onLoadMore, hasMore, tableHeight = '44rem', tournamentTable } = props;
    const youText = translate('You');
    const headersText = tournamentTable
        ? [translate('Rank'), translate('User'), translate('DevCoins')]
        : [translate('Rank'), translate('User'), translate('Teams'), translate('DevCoins')];
    const headers = headersText.map((text, i) => <div key={i}>{text}</div>);

    const [rows, setRows] = useState<CollapseTableData[]>([]);

    useEffect(() => {
        const tmpRows: CollapseTableData[] = users?.map((user: UserData, i: number) => ({
            row: getRow(user, i, currentUser.nickname, youText, true, !tournamentTable)
        }));
        setRows(tmpRows);
    }, [users]);

    return (
        <>
            {rows.length > 0 ? (
                <AccordionTable
                    rows={rows}
                    title=""
                    isOpen={true}
                    hasMoreRows={hasMore}
                    loadMoreRows={onLoadMore}
                    showTitle={false}
                    tableHeight={tableHeight}
                    headers={headers}
                    cellsWidths={tournamentTable ? ['20%', '56%', '28%'] : ['13%', '28%', '28%', '28%']}
                    firstStickyRow={getRow(currentUser, -1, currentUser.nickname, youText, true, !tournamentTable)}
                />
            ) : (
                <div className="no-data">{translate('NoData')}</div>
            )}
            {users.length === 0 && (
                <div className={styles['empty-leaderboard']}>
                    <div className={styles.title}>{translate('NoOneTookAChallengeYet')}</div>
                    <div className={styles['sub-title']}>
                        {translate('TakeAnyChallengeFromTheCatalogToShowOnFirstPlace')}
                    </div>
                    <img
                        className={styles.image}
                        src={`${process.env.PUBLIC_URL}/images/challengeBackground.svg`}
                        alt="challenge"
                    />
                </div>
            )}
        </>
    );
};

interface UserLeaderboardProps {
    tournamentTable: boolean;
    currentUser: UserData;
    users: UserData[];
    onLoadMore: Function;
    hasMore: boolean;
    tableHeight?: string;
}

export default UserLeaderboard;
